<template>

</template>

<script>
export default {
  name: 'ForumsListNotConfirmed'
}
</script>

<style scoped>

</style>
